// THIS ONLY FOR EXAMPLE
import { atom } from "recoil";

const exampleClickedAtom = atom({
  key: "exampleClickedState",
  default: false,
});

export default exampleClickedAtom;
